import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { ROUTES } from '../../../core/constants/routes.constants';
import { SidebarLink } from '../../interfaces/layout.type';
import { SidebarService } from '../../../core/services/sidebar.service';

@Component({
  selector: 'app-admin-sidebar',
  imports: [RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './admin-sidebar.component.html',
  styleUrl: './admin-sidebar.component.scss'
})
export class AdminSidebarComponent {
  protected readonly sidebarService = inject(SidebarService);
  protected readonly routes = ROUTES;

  protected readonly navLinks: SidebarLink[] = [
    { icon: '🏠', label: 'nav.dashboard', path: ROUTES.DASHBOARD, exact: true },
    { icon: '🕐', label: 'nav.prayers', path: ROUTES.DASHBOARD_PRAYER_TIMES },
    { icon: '📖', label: 'nav.al_quran', path: ROUTES.DASHBOARD_QURAN },
    { icon: '📿', label: 'nav.duas_azkar_short', path: ROUTES.DASHBOARD_DUAS_AZKAR },
    { icon: '📚', label: 'nav.islamic_library', path: ROUTES.DASHBOARD_ISLAMIC_LIBRARY },
    { icon: '✅', label: 'nav.kaza_tracker', path: ROUTES.DASHBOARD_KAZA_TRACKER },
    { icon: '📅', label: 'nav.amaal_planner_short', path: ROUTES.DASHBOARD_AMAAL_PLANNER },
    { icon: '📿', label: 'nav.tasbeeh_counter', path: ROUTES.DASHBOARD_TASBEEH_COUNTER },
    { icon: '🧭', label: 'nav.qibla_finder_short', path: ROUTES.DASHBOARD_QIBLA_FINDER },
    { icon: '🕌', label: 'nav.masjid_locator', path: ROUTES.DASHBOARD_MASJIDS },
    { icon: '📆', label: 'nav.islamic_calendar', path: ROUTES.DASHBOARD_ISLAMIC_CALENDAR },
    { icon: '🧒', label: 'nav.kids_mode', path: ROUTES.DASHBOARD_KIDS_MODE }
  ];

  protected readonly jannahJourney = {
    level: 3,
    xp: 680,
    xpTarget: 1000
  };

  protected get jannahJourneyPercent(): number {
    return (this.jannahJourney.xp / this.jannahJourney.xpTarget) * 100;
  }
}
